import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { LeagueFormData } from './useRegisterLeague'

interface StepLeagueDetailsProps {
  formData: LeagueFormData
  onUpdate: (updates: Partial<LeagueFormData>) => void
  onNext: () => void
}

export function StepLeagueDetails({ formData, onUpdate, onNext }: StepLeagueDetailsProps) {
  const [nameError, setNameError] = useState<string | null>(null)

  const handleNext = () => {
    const name = formData.name.trim()
    if (name.length < 3) {
      setNameError('League name must be at least 3 characters')
      return
    }
    if (name.length > 50) {
      setNameError('League name must be 50 characters or less')
      return
    }
    setNameError(null)
    onNext()
  }

  return (
    <div>
      <h2 className="text-xl font-bold text-zinc-800 dark:text-zinc-100 mb-1">Name your league</h2>
      <p className="text-zinc-500 dark:text-zinc-400 text-sm mb-6">
        Choose a name for your league.
      </p>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="league-name">League Name *</Label>
          <Input
            id="league-name"
            type="text"
            placeholder="e.g. The Sunday League"
            value={formData.name}
            onChange={(e) => {
              onUpdate({ name: e.target.value })
              if (nameError) setNameError(null)
            }}
            maxLength={50}
            autoFocus
          />
          {nameError && (
            <p className="text-sm text-red-600 dark:text-red-400">{nameError}</p>
          )}
          <p className="text-xs text-zinc-500">{formData.name.length}/50 characters</p>
        </div>

        <Button onClick={handleNext} className="w-full">
          Continue
        </Button>
      </div>
    </div>
  )
}
